import React, { HTMLAttributes } from 'react';
import { styled } from '@linaria/react';
import { ThemeType } from 'types/Theme';
import { cssTheme } from '../../../../themes';
type Spacing = keyof ThemeType['layout']['spacing'];
type overflowTypes = 'auto' | 'scroll' | 'hidden';
interface Props {
  /** Content to be displayed inside the Stack */
  children: React.ReactNode;
  /** Horizontal space between elements. **/
  columnGap?: Spacing;
  /** Vertical space between elements when they wrap on desktop. **/
  rowGap?: Spacing;
  /** Accepts a custom class name, also adds the ability to customize the component using styled(HorizontalScroll), use this to add page margins */
  className?: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Scroll event */
  onScroll?: HTMLAttributes<HTMLDivElement>['onScroll'];
  /** Horizontal overflow */
  overflowX?: overflowTypes;
}
const _exp = /*#__PURE__*/() => ({
  overflowX
}) => overflowX;
const _exp2 = /*#__PURE__*/() => ({
  columnGap
}) => columnGap ? cssTheme.layout.spacing[columnGap] : 'inherit';
const _exp4 = /*#__PURE__*/() => ({
  rowGap
}) => rowGap ? cssTheme.layout.spacing[rowGap] : 'inherit';
const HorizontalScrollContainer = /*#__PURE__*/styled('div')({
  name: "HorizontalScrollContainer",
  class: "h1xl81zh",
  propsAsIs: false,
  vars: {
    "h1xl81zh-0": [_exp()],
    "h1xl81zh-1": [_exp2()],
    "h1xl81zh-2": [_exp4()]
  }
});
export const HorizontalScroll = ({
  className,
  dataId,
  children,
  columnGap = 's000',
  rowGap = 's000',
  overflowX = 'scroll',
  onScroll
}: Props) => <HorizontalScrollContainer className={className} data-id={dataId} columnGap={columnGap} rowGap={rowGap} overflowX={overflowX} {...onScroll ? {
  onScroll
} : {}}>
    {children}
  </HorizontalScrollContainer>;

require("./HorizontalScroll.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HorizontalScroll.tsx");